// Tri Nature — Baby & Kids range. Live data from trinature.com.au (June 2026).
window.TN_PRODUCTS = [
  {
    id: 'koala',
    animal: 'Koala',
    buddy: 'Koko',
    bio: 'The sleepy one. Koko runs the evening wind down, with warm water, lavender, heavy eyelids. Asleep before the towel comes out.',
    name: 'Baby Wash',
    scent: 'Chamomile & Lavender',
    size: '500mL',
    price: '$21.95',
    url: 'https://trinature.com.au/collections/baby-kids-care/products/baby-wash?variant=53150248894827',
    line: 'A calming wash for warm evening baths, with chamomile and lavender to settle little ones before sleep.',
    bottle: 'assets/bottles/bottle-koala.png',
    cutout: 'assets/animals/koala.png',
    peek: { side: 'right', rise: 46 }
  },
  {
    id: 'kangaroo',
    animal: 'Kangaroo',
    buddy: 'Katie',
    bio: 'Big sibling energy. Katie bounces in first, checks the water, and stays close until everyone’s clean, dry and accounted for.',
    name: 'Baby Wash',
    scent: 'Vanilla & Oatmeal',
    size: '500mL',
    price: '$21.95',
    url: 'https://trinature.com.au/collections/baby-kids-care/products/baby-wash?variant=53150248862059',
    line: 'A soft milk wash designed to pamper baby\u2019s delicate skin leaving it soft and clean.',
    bottle: 'assets/bottles/bottle-kangaroo.png',
    cutout: 'assets/animals/kangaroo.png',
    peek: { side: 'left', rise: 50 }
  },
  {
    id: 'galah',
    animal: 'Galah',
    buddy: 'Gabe',
    bio: 'The entertainer. Gabe believes there is no such thing as too many bubbles and will argue the point loudly, nightly.',
    name: 'Kids Bubble Bath & Wash',
    scent: 'Cherry Blossom',
    size: '500mL',
    price: '$19.95',
    url: 'https://trinature.com.au/collections/baby-kids-care/products/kids-bubble-bath-and-wash-cherry-blossom?variant=53285131714923',
    line: 'Mountains of gentle bubbles, scented with cherry blossom. Bath time\u2019s new best friend.',
    bottle: 'assets/bottles/bottle-galah.png',
    cutout: 'assets/animals/galah.png',
    peek: { side: 'right', rise: 48 }
  },
  {
    id: 'quokka',
    animal: 'Quokka',
    buddy: 'Quincy',
    bio: 'The smiley one. Quincy has never met a tangle she couldn’t talk out of a knot. No tears, promise, it’s her whole thing.',
    name: 'Kids 2 in 1 Shampoo & Conditioner',
    scent: 'Pear & Raspberry',
    size: '500mL',
    price: '$21.95',
    url: 'https://trinature.com.au/collections/baby-kids-care/products/kids-2-in-1-shampoo-conditioner?variant=53150232543595',
    line: 'One pump, no tears, no tangles. Pear and raspberry softness from tub to towel.',
    bottle: 'assets/bottles/bottle-quokka.png',
    cutout: 'assets/animals/quokka.png',
    peek: { side: 'left', rise: 44 }
  },
  {
    id: 'platypus',
    animal: 'Platypus',
    buddy: 'Pearl',
    bio: 'The quiet water baby. Pearl likes slow mornings, warm hands and long cuddles, keeping the calm moments calm.',
    name: 'Mum & Baby Massage Oil',
    scent: 'Chamomile & Lavender',
    size: '200mL',
    price: '$29.95',
    url: 'https://trinature.com.au/collections/baby-kids-care/products/baby-massage-oil?variant=53150238245227',
    line: 'For quiet moments together. A light, nourishing oil for mum\u2019s skin and baby\u2019s, too.',
    bottle: 'assets/bottles/bottle-platypus.png',
    cutout: 'assets/animals/platypus.png',
    peek: { side: 'right', rise: 40 }
  }
];

window.TN_COLLECTION_URL = 'https://trinature.com.au/collections/baby-kids-care';

/* ─────────────────────────────────────────────────────────────────────────────
   Tri Nature — baby range cart wiring
   Added 5 August 2026 by Fallon Digital.

   WHY THIS EXISTS
   The baby-range template's "Add to cart" buttons were decorative. They
   incremented a local counter and showed a toast, but never called
   /cart/add.js, so nothing ever reached the Shopify cart. The floating bag
   button had no working handler, and the template suppresses the theme header,
   so the page had no route to /cart at all.

   This wires the existing buttons to the real cart without touching the page's
   markup or its animations. Variant ids are read from window.TN_PRODUCTS[].url.

   Verified live on 5 August 2026: add to cart puts the correct variant in the
   real Shopify cart, the badge reads the true cart count, and the bag button
   goes to /cart.

   Covers both /pages/baby-range and /pages/baby-range-business.
   ───────────────────────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  function findProduct(id) {
    var list = window.TN_PRODUCTS || [];
    for (var i = 0; i < list.length; i++) {
      if (list[i].id === id) return list[i];
    }
    return null;
  }

  function variantIdOf(p) {
    if (!p) return '';
    var m = String(p.url || '').match(/variant=(\d+)/);
    return m ? m[1] : '';
  }

  /* Show the real cart count, not a counter that resets to zero every visit. */
  function refreshBadge() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var badge = document.getElementById('bagCount');
        var bag = document.getElementById('bagBtn');
        var n = cart.item_count || 0;
        if (badge) badge.textContent = n;
        if (bag) bag.classList.toggle('has', n > 0);
        return n;
      })
      .catch(function () { return null; });
  }

  ready(function () {
    var drops = document.getElementById('drops');
    var bag = document.getElementById('bagBtn');

    /* The toast claimed there was something in the bag when there wasn't. */
    var sub = document.querySelector('.toast .t-sub');
    if (sub) sub.textContent = 'Tap the bag to check out';

    refreshBadge();

    /* Capture phase, so this runs alongside the template's own animation handler
       rather than replacing it. The bottle still flies into the bag. */
    if (drops) {
      drops.addEventListener('click', function (e) {
        var btn = e.target && e.target.closest ? e.target.closest('.btn-bag') : null;
        if (!btn) return;

        var p = findProduct(btn.getAttribute('data-id'));
        var vid = variantIdOf(p);
        var url = p ? p.url : '';

        /* No variant id, or the add fails: send them to the product page,
           which is a working purchase path, rather than nowhere. */
        if (!vid) {
          if (url) window.location.href = url;
          return;
        }
        if (btn.getAttribute('data-busy') === '1') return;
        btn.setAttribute('data-busy', '1');

        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(vid), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) { throw new Error('add to cart failed: ' + r.status); }
            return r.json();
          })
          .then(function () { return refreshBadge(); })
          .catch(function () { if (url) window.location.href = url; })
          .then(function () { btn.setAttribute('data-busy', '0'); });
      }, true);
    }

    /* The bag button had no handler that went anywhere. Send it to the cart. */
    if (bag) {
      bag.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        window.location.href = '/cart';
      }, true);
    }
  });
})();
